$(document).ready(function() {
 /*---------------- Start Blog UP/Down JS  ---------------- */

  jQuery('.collection_cms_slider .wrapp-category:odd').addClass('odd');
  jQuery('.collection_cms_slider .wrapp-category:even').addClass('even');

  jQuery('.collection_cms_slider .wrapp-category.odd .collection_cat_item').each(function(index, element) {
    var html = '';
    html += '<div class="tb-collection-content right-block">' + jQuery(element).find('.right-block').html() + '</div>';
    html += '<div class="collection_img left-block">' + jQuery(element).find('.left-block').html() + '</div>';
    jQuery(element).html(html);
  });

  /*---------------- End Blog UP/Down JS  ---------------- */  
  
   var tb_blogs_cms = $('#blog_slider').owlCarousel({
      items : 3, //1 items above 1000px browser width
      nav: false,
      dots: true,
      loop: false,
      center: false,
      autoplayHoverPause: true,
      autoplay:true,
      responsive: {
              0:{
                  items:1
              },
              544:{
                  items:2
              },
              768:{
                  items:2
              },
              992:{
                  items:3
              },
              1200:{
                  items:3
              }
          }
  });
});
